import React from 'react'
import PropTypes from 'prop-types'
import DateModified from 'src/components/dateModified'
import { Helmet } from 'react-helmet'

import { contentExists } from 'src/utils/ug-utils'

import 'src/styles/global.css'
import 'src/uglib_styles/uglib.css'
import 'src/uglib_styles/uglib-buttons.css'
import 'src/uglib_styles/tables.css'

import Seo from 'src/uglib_components/seo'

import ServiceDisruptionBar from 'src/uglib_components/serviceDisruptionBar'
import Notices from 'src/uglib_components/notices'
import BuildingCapacityNotice from 'src/uglib_components/buildingCapacityNotice'
import BuildingHoursNotice from './buildingHoursNotice'
import Breadcrumbs from 'src/uglib_components/breadcrumbs'
import A11yMessage from 'src/uglib_components/a11yMessage'
import HeaderMenu from 'src/uglib_components/headerMenu'
import Banners from 'src/uglib_components/banners'

import Footer from './footer'

import AskChatTab from './askChatTab'

const Layout = ({ title, header, keywords, bodyClass, contentHead, children, date, breadcrumbs, applyStyles }) => {

    const defaultHeader = <>
        <Helmet bodyAttributes={{
            class: bodyClass
        }}
        />

        <Helmet><script defer type="text/javascript" src="/assets/uglib_embeds.js"></script></Helmet>
        <Helmet><script defer type="text/javascript" src="/assets/uog-media-player.js"></script></Helmet>
        <Seo title={title} keywords={keywords} />

        { /**** Header and Title ****/ }
        {/* <OmniHeader title={title} /> */}
		<div id="rotator" className="no-thumb">			
			<div className="container ft-container">
				<h1 className="fancy-title">{title}</h1>
			</div>
		</div>

        <Breadcrumbs nodeTitle={title} links={breadcrumbs} />
    </>;

    const defaultContentHead = <>
        <ServiceDisruptionBar />
        <Banners />
        <Notices>
            <BuildingHoursNotice />
            <BuildingCapacityNotice />
        </Notices>
    </>;

    /*
	 * The "site-content" class applies a bunch of style rules on the content.
	 * Sometimes we don't want that to happen, so we can use the applyStyles prop to conditionally add this class
	 **/
	let content_classes = ['row', 'row-with-vspace']
	if (applyStyles) {
		content_classes.push('site-content');
	}

    return (<>
        <HeaderMenu menuName="main" />
        {contentExists(header) ? header : defaultHeader}

        <main id="content" className="main-container">
            <div className="container page-container">
                {contentExists(contentHead) ? contentHead : defaultContentHead}
                <div className={content_classes.join(' ')}>
                    <DateModified date={date}/>
                    {children}
                </div>
            </div>

            <div className="container col col-12">
                <A11yMessage />
            </div>
            <AskChatTab />
        </main>

        <Footer />
    </>);
}

Layout.propTypes = {
    title: PropTypes.string,
    keywords: PropTypes.array,
    bodyClass: PropTypes.string,
    header: PropTypes.node,
    contentHead: PropTypes.node,
    children: PropTypes.node.isRequired,
    date: PropTypes.string,
    breadcrumbs: PropTypes.array,
    applyStyles: PropTypes.bool,
}

Layout.defaultProps = {
    applyStyles: true,
    title: "Library",
    keywords: [],
    bodyClass: "",
    date: "",
    breadcrumbs: [],
}

export default Layout
